import React from 'react';

import { InformationDisplayBlock } from '../../../../../components';
import { REGISTRATION_TEXT } from '../../../../Application/components/ApplicationStatus/Registration/lang';
import { AssessmentAccordion } from '../../../../Assessment';
import type { ApplicantBasic } from '../../../graphql';
import { QUALIFICATION_PAGE_TEXT } from '../../../lang';

export type ValidationApplicantParticularProps = {
  applicantBasicData: ApplicantBasic;
};

export const ValidationApplicantParticular: React.FunctionComponent<
  ValidationApplicantParticularProps
> = props => {
  const { applicantBasicData } = props;

  const {
    applicationNumber,
    nameInEnglishSurname,
    nameInEnglishGivenName,
    nameInChinese,
    emailAddress,
    dateOfBirth,
    gender,
    nationalityCountryRegion,
    identityType,
    identityNumber,
  } = applicantBasicData;

  const particularMap = [
    { label: REGISTRATION_TEXT.APPLICATION_NO, value: applicationNumber },
    { label: REGISTRATION_TEXT.ENGLISH_SURNAME, value: nameInEnglishSurname },
    {
      label: REGISTRATION_TEXT.ENGLISH_GIVENNAME,
      value: nameInEnglishGivenName,
    },
    { label: REGISTRATION_TEXT.CHINESE_NAME, value: nameInChinese },
    { label: REGISTRATION_TEXT.EMAIL_ADDRESS, value: emailAddress },
    {
      label: REGISTRATION_TEXT.DATE_OF_BIRTH,
      value: dateOfBirth,
    },
    {
      label: REGISTRATION_TEXT.GENDER,
      value: gender,
    },
    {
      label: REGISTRATION_TEXT.NATIONALITY_REGION,
      value: nationalityCountryRegion,
    },
    { label: REGISTRATION_TEXT.IDENTITY_TYPE, value: identityType },
    {
      label: REGISTRATION_TEXT.IDENTITY_NUMBER,
      value: identityNumber,
    },
  ];

  return (
    <AssessmentAccordion
      title={QUALIFICATION_PAGE_TEXT.BASIC_INFORMATION}
      titlecolor="#951D1D"
      defaultExpanded
      AssessDetails={<InformationDisplayBlock blockData={particularMap} />}
    />
  );
};
